function uniform(): number {
	return crypto.getRandomValues(new Uint32Array(1))[0] / (0xffffffff + 1);
}

function int(min: number, max: number): number {
	if (!Number.isInteger(min) || !Number.isInteger(max)) {
		throw new Error(`min: ${min} or max: ${max} is not an integer`);
	}
	return Math.floor(uniform() * (max - min + 1) + min);
}

function item<T>(items: { [index: number]: T; length: number }): T {
	return items[Math.floor(uniform() * items.length)];
}

export default {
	uniform,
	int,
	item,
};
